import Phaser from 'phaser';
import { TEX } from '@/data/assetManifest';
import { T, TH } from '@/data/tileIndex';
import { TilemapRenderer } from '@/systems/TilemapRenderer';
import { AudioManager } from '@/systems/AudioManager';
import { useCharacterStore } from '@/state/characterStore';

// Dungeon prototype: real-asset stone floor + wall borders + torches.
// 40x30 tiles = 1280x960 px (single floor F1 layout)
const D_W = 40, D_H = 30, TILE = 32;
const D_PIX_W = D_W * TILE, D_PIX_H = D_H * TILE;

export class DungeonScene extends Phaser.Scene {
  constructor() { super('Dungeon'); }
  create() {
    const ch = useCharacterStore.getState().current;
    if (ch) useCharacterStore.getState().setPosition({ x: ch.posX ?? 100, y: ch.posY ?? 100, mapId: 4 });
    AudioManager.play(this, 'bgm_dungeon_calm');
    this.cameras.main.setBounds(0, 0, D_PIX_W, D_PIX_H);
    const r = new TilemapRenderer(this, D_W, D_H, TILE);
    // Stone floor base (gray cobble)
    r.fill(T.pathCobble);
    // Some wood plank rooms
    r.rect(4, 4, 14, 10, T.woodFloorH);
    r.rect(20, 4, 32, 10, T.woodFloorV);
    r.rect(4, 16, 14, 24, T.woodFloorV);
    r.rect(20, 16, 32, 24, T.woodFloorH);
    // Walls all around the perimeter
    for (let x = 0; x < D_W; x++) {
      r.setTile(x, 0, T.wallBrickTopM);
      r.setTile(x, D_H - 1, T.wallBrickTopM);
    }
    for (let y = 0; y < D_H; y++) {
      r.setTile(0, y, T.wallBrickTopL);
      r.setTile(D_W - 1, y, T.wallBrickTopR);
    }
    r.render();

    // Torches on walls
    const torchPos: Array<[number, number]> = [
      [4, 1], [10, 1], [16, 1], [22, 1], [28, 1], [34, 1],
      [4, D_H - 2], [16, D_H - 2], [28, D_H - 2],
    ];
    for (const [x, y] of torchPos) {
      this.add.image(x * TILE, y * TILE, TEX.tinyThings, TH.torchOrangeLit).setScale(TILE / 16).setDepth(y * TILE);
    }
    // Random chests/pots scattered
    const lootPos: Array<[number, number, number]> = [
      [8, 6, TH.chestS], [10, 8, TH.chestSGold], [24, 6, TH.potM],
      [28, 18, TH.chestM], [12, 20, TH.potL],
    ];
    for (const [x, y, idx] of lootPos) {
      this.add.image(x * TILE, y * TILE, TEX.tinyThings, idx).setScale(TILE / 16).setDepth(y * TILE);
    }

    this.add.text(20, 20, 'Dungeon F1 (Tiny16)', {
      fontFamily: '"Philosopher", "Cinzel", serif', fontSize: '18px', color: '#fff', stroke: '#000', strokeThickness: 3,
    }).setScrollFactor(0).setDepth(100);
    this.add.text(20, D_PIX_H - 30, 'Esc: về Town', {
      fontFamily: '"Philosopher", "Cinzel", serif', fontSize: '14px', color: '#cfd8dc',
    }).setScrollFactor(0).setDepth(100);
  }
}
